import React from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';
import { FormattedMessage } from 'react-intl';
import get from 'lodash.get';
import { PROMO } from '../../../checkout/constants/checkoutConstants.es';
import styles from './styles/PromoCode.scss';

const PromoCode = ({ user, pricingDisplayInfo }) => {
    return (
        !!get(user, 'isPromoCodeEligible') && (
            <div className={styles.container}>
                <FormattedMessage
                    id="pdp.PromoCode.code"
                    defaultMessage={`
                    {discountDisplay, select,
                        true {Extra}
                        other {}
                    } {discount}% off with code: {code}
                `}
                    values={{
                        discount: PROMO.DISCOUNT,
                        code: PROMO.CODE,
                        discountDisplay:
                            pricingDisplayInfo.showSalePrice || pricingDisplayInfo.showNetPrice,
                    }}
                />
            </div>
        )
    );
};

PromoCode.propTypes = {
    user: PropTypes.object,
    pricingDisplayInfo: PropTypes.object,
};

PromoCode.defaultProps = {
    pricingDisplayInfo: {},
};

export default createFragmentContainer(PromoCode, {
    user: graphql`
        fragment PromoCode_user on User {
            isPromoCodeEligible(code: "SAVE15")
        }
    `,
});



// WEBPACK FOOTER //
// ./assets/js/newPdp/components/Sidebar/PromoCode.jsx